import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";

const AssignedVendor = ({ vendorData, customerCode, assignedVendorCode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedVendorCode, setSelectedVendorCode] = useState(assignedVendorCode);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!selectedVendorCode) {
      toast.error("Please select a vendor.");
      return;
    }

    const data = {
      customerCode: customerCode,
      assignedVendorCode: selectedVendorCode,
    };

    setLoading(true);
    try {
      const response = await axiosPostApi(apiList.ASSIGN_VENDOR_CODE, data);

      if (response?.data?.status === true) {
        toast.success("Vendor assigned successfully!", {
          position: "top-right",
          autoClose: 2000,
        });
        navigate(location.pathname, {
          replace: true,
          state: { ...location.state, assignedVendorCode: selectedVendorCode },
        });
      } else {
        CustomAlert({
          title: "Failed to Assign Vendor",
          text:
            response?.data?.message ||
            "There was an issue processing the request. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      toast.error("Failed to assign vendor. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assigned-vendor-container">
      <div className="d-flex align-items-end gap-3 first-tab-controls">
        <div>
          <label htmlFor="vendorSelect">Vendor</label>
          <select
            id="vendorSelect"
            className="dropdown-select"
            value={selectedVendorCode}
            onChange={(e) => setSelectedVendorCode(e.target.value)}
          >
            <option value="">Select Vendor</option>
            {vendorData.map((vendor) => (
              <option key={vendor.vendorCode} value={vendor.vendorCode}>
                {vendor.vendorName}
              </option>
            ))}
          </select>
        </div>
        <button
          className="btn addUser"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} color="inherit" /> : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default AssignedVendor;
